var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 26.25L20.8213 20.8213M20.8213 20.8213C21.7499 19.8927 22.4865 18.7902 22.989 17.5769C23.4916 16.3637 23.7503 15.0633 23.7503 13.75C23.7503 12.4368 23.4916 11.1364 22.989 9.92308C22.4865 8.70979 21.7499 7.60737 20.8213 6.67876C19.8927 5.75015 18.7902 5.01354 17.5769 4.51098C16.3637 4.00842 15.0633 3.74976 13.75 3.74976C12.4368 3.74976 11.1364 4.00842 9.92308 4.51098C8.70979 5.01354 7.60737 5.75015 6.67876 6.67876C4.80335 8.55418 3.74976 11.0978 3.74976 13.75C3.74976 16.4022 4.80335 18.9459 6.67876 20.8213C8.55418 22.6967 11.0978 23.7503 13.75 23.7503C16.4022 23.7503 18.9459 22.6967 20.8213 20.8213Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0d51e1295e02900320f7c4ee42ce4774.svg";
export { ForwardRef as ReactComponent };